import { render, staticRenderFns } from "./Sales.vue?vue&type=template&id=4068c838&scoped=true"
import script from "./Sales.vue?vue&type=script&lang=js"
export * from "./Sales.vue?vue&type=script&lang=js"
import style0 from "./Sales.vue?vue&type=style&index=0&id=4068c838&prod&scoped=true&lang=css"
import style1 from "./Sales.vue?vue&type=style&index=1&id=4068c838&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4068c838",
  null
  
)

export default component.exports